import socketIOClient from 'socket.io-client'
import { SET_LOBBY_LIST, SET_ANNOUNCEMENT, SHOW_POPUP } from '../redux/actions/type'
let socket

export const initiateSocket = (name, dispatch, chatID) => {
    socket = socketIOClient(`${window._env_.lobbyAPIUrl}lobby-manager`, {
        query: {
            vtoken: localStorage.getItem('vtoken'),
            name: encodeURIComponent(name.roomName)
        }
    });
    socket.on('onConnect', function (data) {
        if (data.code !== 200)
            window.location.href = `${window._env_.vRoomUrl}/portal/notFound`
        console.log('onConnect', data)
    });
    socket.emit('setChatID', chatID, function (data) {
        console.log('setChatID::', data);
    });
    socket.on('userList', function (data) {
        dispatch({
            type: SET_LOBBY_LIST,
            payload: {
                lobbyLists: data
            }
        })
        console.log("userList", data)
    });
    socket.on('announcement', function (data) {
        dispatch({
            type: SET_ANNOUNCEMENT,
            payload: {
                announcement: data
            }
        })
    });
    socket.on('roomExpire', function () {
        dispatch({
            type: SHOW_POPUP,
            payload: {
                isShow: true,
                textBody: 'popupInfo.body',
                textButton: "popupInfo.button_my_meeting",
                action: `${window._env_.mymeeting}`
            }
        })
    });
}

export const ChangeName = (name, id) => {
    if (socket) {
        socket.emit('setProfile', { name, id }, function (data) {
            console.log('setProfile', data);
        });
    }

}

export const connectSetChatID = (chatID) => {
    if (socket) {
        socket.emit('setChatID', chatID, function (data) {
            console.log('setChatID::', data);
        });
    }

}

export const ConnectChat = () => {

    if (socket) {
        return socket
        // socket.emit('chat', userID.id, function (data) {
        //     console.log('chat', data);
        //     if (data.code === 200) {
        //         localStorage.setItem("chatCodeStatus", data.code)
        //     }

        // });
    }
}

export const Reject = (userID) => {
    if (socket) {
        socket.emit('reject', userID.id, function (data) {
            console.log('reject', data);
        });
    }

}

export const connectApproveUser = (id) => {
    if (socket) {
        socket.emit('approve', { vtoken: localStorage.getItem('vtoken'), id }, function (data) {
            console.log('approve', data);
        })
    }
}

export const updateAnnouncement = (text) => {
    if (socket) {
        return new Promise((resolve) => {
            socket.emit('announcement', text, function () {
                resolve();
            });
        });
    }
}